<template>
  <div>
    <div v-if="isVisible" id="loading">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewbox="0 0 40 40"
        width="40"
        height="40"
      >
        <circle cx="20" cy="20" r="20" />
      </svg>
      <div class="text-container">
        <h2>Deine Datei wird verarbeitet</h2>
        <h2>Das kann bis zu einer Minute dauern</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    isVisible: Boolean,
  },
}
</script>

<style scoped lang="scss">
#loading {
  background: #f5f5f5;
  opacity: 0.9;
  z-index: 100;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
  svg {
    background-color: var(--colorPrimary);
    circle {
      fill: none;
      stroke: #f0ece6;
      stroke-width: 40px;
      shape-rendering: geometricPrecision;
      stroke-dasharray: 125;
      stroke-dashoffset: 250;
      transform-origin: 50%;
      transform: rotate(-90deg);
      animation: animate 2s linear infinite;
    }
    @keyframes animate {
      to {
        stroke-dashoffset: 0;
      }
    }
  }
}

.text-container {
  text-align: center;
}

@media only screen and (max-width: 480px) {
  #loading {
    padding-top: 5em;
    justify-content: start;
  }
  .text-container {
    padding: 2em;
  }
}
</style>
